import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { StoreEmployeeRequirement } from '../../../models/store/StoreEmployeeRequirement';
import { StoreEmployeeRequirementsResponse } from '../../../../interfaces/response/StoreResponses';

/**
 * An adapter converts store employee requirement HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class StoreEmployeeRequirementAdapter implements Adapter<StoreEmployeeRequirement[]> {

  /**
   * Converts store employee requirement HTTP response to a list of {@link StoreEmployeeRequirement}.
   * @param item store employee requirement HTTP response.
   */
  adapt(item: StoreEmployeeRequirementsResponse[]): StoreEmployeeRequirement[] {
    if (!item) {
      return [];
    }
    const result: StoreEmployeeRequirement[] = [];
    item.forEach($item => {
      result.push(new StoreEmployeeRequirement(
        $item.date,
        $item.minimumOpeningEmployees,
        $item.minimumRegularEmployees,
        $item.minimumClosingEmployees,
      ));
    });
    return result.sort((previous, current) => current.startDate < previous.startDate ? 1 : -1);
  }
}
